import { render, staticRenderFns } from "./PuzzleItem.vue?vue&type=template&id=1f8adae3&scoped=true&"
import script from "./PuzzleItem.vue?vue&type=script&lang=js&"
export * from "./PuzzleItem.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleItem.vue?vue&type=style&index=0&id=1f8adae3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8adae3",
  null
  
)

export default component.exports